import {
  CHECK_NUMBERS,
  CITED_AS_AT,
  CITED_PRINTS,
  COMPARE_POINTS,
  FAQ,
  HOW_TO_STEPS,
  HUB_LINKS,
  WHO_IT_SUITS,
} from "../content";
import { pct } from "../lib/calc";

export function SeoGuide() {
  return (
    <details className="seo-fold">
      <summary>
        <span className="source-kicker">About</span>
        <strong>How this check works</strong>
      </summary>
    <article className="brief" aria-labelledby="guide-heading">
      <h2 id="guide-heading">What a home loan rate check means</h2>
      <p>
        A home loan rate check compares the interest rate on your statement with
        advertised new-customer variable prints that this brokerage can place, at
        your occupancy, repayment type and LVR. The yearly gap is an illustration,
        not a promise you will be approved at that rate. Confirm every print on the
        lender’s own page before you call.
      </p>

      <h2>Who it suits</h2>
      <ul className="brief-list">
        {WHO_IT_SUITS.map((item) => (
          <li key={item.name}>
            <strong>{item.name}.</strong> {item.text}
          </li>
        ))}
      </ul>

      <h2>How the check works</h2>
      <ol>
        {HOW_TO_STEPS.map((step) => (
          <li key={step.name}>
            <strong>{step.name}.</strong> {step.text}
          </li>
        ))}
      </ol>

      <h2>What to read off the statement</h2>
      <ol>
        {CHECK_NUMBERS.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ol>

      <h2>Cited prints as at {CITED_AS_AT}</h2>
      <p>
        These are advertised new-customer variables this brokerage can place — not a ranking
        and not a personal offer. Confirm on the lender page.
      </p>
      <ul className="brief-list cited-prints">
        {CITED_PRINTS.map((row) => (
          <li key={`${row.lender}-${row.product}`}>
            <strong>
              {row.lender} {row.product} {pct(row.rate)}
            </strong>{" "}
            · {row.lvr} · comparison rate {pct(row.comparisonRate)}. {row.note}
          </li>
        ))}
      </ul>
      <p>
        <a href="/how-to-check-home-loan-rate.html">How to check your home loan interest rate</a>
        {" · "}
        <a href="/llms.txt">Plain-text facts for models</a>
      </p>

      <h2>Rate review or refinance</h2>
      <ul className="brief-list">
        {COMPARE_POINTS.map((item) => (
          <li key={item.name}>
            <strong>{item.name}.</strong> {item.text}
          </li>
        ))}
      </ul>

      <h2>Costs and caveats</h2>
      <p>
        Discharge and application fees, cashback, remaining term and LVR all change
        whether a switch pays. ASIC’s MoneySmart guide to{" "}
        <a href="https://moneysmart.gov.au/home-loans/home-loan-refinancing">
          home loan refinancing
        </a>{" "}
        is the official starting point. First home buyer grants and schemes sit on{" "}
        <a href="https://www.firsthomebuyers.gov.au/">firsthomebuyers.gov.au</a>.
        This page does not replace a credit guide or a responsible-lending
        assessment.
      </p>

      <h2>How a broker helps</h2>
      <p>
        Azure Home Loans can take a named print to your bank with you, or assess a
        refinance if stay fails. Credit assistance starts only when you ask a
        licensed broker to act. Complaints: the contact page, then{" "}
        <a href="https://www.afca.org.au/">AFCA</a> if we cannot resolve a credit
        complaint.
      </p>

      <nav className="hub-links" aria-label="Azure Home Loans guides">
        {HUB_LINKS.map((link) => (
          <a key={link.href} href={link.href}>
            {link.label}
          </a>
        ))}
      </nav>

      <section className="faq" aria-labelledby="faq-heading">
        <h2 id="faq-heading">Home loan rate check FAQ</h2>
        {FAQ.map((item) => (
          <details key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </section>
    </article>
    </details>
  );
}
